/* eslint-disable max-len */
import React, { ChangeEvent } from 'react'

import ContractorProfileHeader from '../../../components/contractor-profile-header'
import ContractorProfileSection from '../../../components/contractor-profile-section'
import AddressInfo from '../../../components/adress-info'
import TextArea from './text-area'
import Icon from '../../../components/icon'
import ListRenderer from '../../../components/list-renderer'

import {
  Button,
  ButtonsContainer,
  Container,
  Content,
  Input,
  SaveButton,
  SpanInfo,
  Text,
} from './styles'

import IProps from './props'

const ProfileContractor = ({
  contractor,
  editableFields,
  isEditing,
  cep,
  number,
  handleLogout,
  handleChangePassword,
  handleEditMode,
  handleEditableField,
  handleSave,
  // handleEditPlan this will be used later, do not remove,
  handleEditAddress,
  handleEditCep,
  handleEditNumber,
  handleClick,
}: IProps) => (
  <Container>
    <ContractorProfileHeader
      contractor={contractor}
      showIcon
      onClick={handleClick}
    />
    <Content>
      <ContractorProfileSection title="Tipo de instituição" noEditable>
        <Text>{contractor.institutionType}</Text>
      </ContractorProfileSection>
      <ContractorProfileSection
        title="Sobre"
        isEditing={isEditing.about}
        onEdit={() => handleEditMode('about')}
      >
        {isEditing.about ? (
          <>
            <TextArea
              label="Sobre"
              value={editableFields.about}
              onChange={(evt: ChangeEvent<HTMLTextAreaElement>) => handleEditableField('about', evt.target.value)}
              autoFocus={isEditing.about}
              maxLength={5000}
            />
            <SaveButton onClick={() => handleSave('about')}>Salvar</SaveButton>
          </>
        ) : (
          <Text>{contractor.about}</Text>
        )}
      </ContractorProfileSection>
      <ContractorProfileSection
        title="Endereço"
        isEditing={isEditing.address}
        onEdit={() => handleEditMode('address')}
      >
        {isEditing.address ? (
          <>
            CEP
            <Input value={cep} onChange={handleEditCep} type="tel" />
            <SaveButton onClick={handleEditAddress}>Buscar</SaveButton>
            Número
            <Input value={number} onChange={handleEditNumber} type="tel" />
            {editableFields.address && (
              <AddressInfo address={editableFields.address} />
            )}
            <SaveButton onClick={() => handleSave('address')}>
              Salvar
            </SaveButton>
          </>
        ) : (
          <AddressInfo address={contractor.address} />
        )}
      </ContractorProfileSection>
      <ContractorProfileSection
        title="Observações"
        isEditing={isEditing.observation}
        onEdit={() => handleEditMode('observation')}
      >
        {isEditing.observation ? (
          <>
            <TextArea
              label="Observações"
              value={editableFields.observation}
              onChange={(evt: ChangeEvent<HTMLTextAreaElement>) => handleEditableField('observation', evt.target.value)}
              autoFocus={isEditing.observation}
              maxLength={5000}
            />
            <SaveButton onClick={() => handleSave('observation')}>
              Salvar
            </SaveButton>
          </>
        ) : (
          <Text>{contractor.observation}</Text>
        )}
      </ContractorProfileSection>
      <ContractorProfileSection
        title="Site da instituição"
        isEditing={isEditing.site}
        onEdit={() => handleEditMode('site')}
      >
        {isEditing.site ? (
          <>
            <Input
              value={editableFields.site}
              onChange={(evt: ChangeEvent<HTMLInputElement>) => handleEditableField('site', evt.target.value)}
            />
            <SaveButton onClick={() => handleSave('site')}>Salvar</SaveButton>
          </>
        ) : (
          contractor.site
        )}
      </ContractorProfileSection>
      <ContractorProfileSection
        title="Horário de funcionamento"
        isEditing={isEditing.availability}
        onEdit={() => handleEditMode('availability')}
      >
        {isEditing.availability ? (
          <>
            <Input
              value={editableFields.availability?.join(',')}
              onChange={(evt: ChangeEvent<HTMLInputElement>) => handleEditableField('availability', evt.target.value.split(','))}
            />
            <SpanInfo>Por favor, separar itens por vírgula.</SpanInfo>
            <SaveButton onClick={() => handleSave('availability')}>
              Salvar
            </SaveButton>
          </>
        ) : (
          <ListRenderer items={contractor.availability} />
        )}
      </ContractorProfileSection>

      {/* <ContractorProfileSection
          title="Seu plano"
          handleEditPlan={handleEditPlan}
        >
          {contractor.plan?.period} -
          {contractor.plan?.promotionalPrice !== null &&
          contractor.plan?.promotionalPrice !== 0 ? (
            <>
              de: R$
              {contractor.plan?.value}
              <span>
                Por: R$
                {contractor.plan?.promotionalPrice}
              </span>
            </>
          ) : (
            <span>
              R$
              {contractor.plan?.value}
            </span>
          )}
        </ContractorProfileSection> this will be used later, do not remove */}
    </Content>
    <ButtonsContainer>
      <Button onClick={handleChangePassword}>
        <Icon name="lock" />
        Alterar minha senha
      </Button>
      <Button onClick={handleLogout}>
        <Icon name="exit" />
        Sair da plataforma
      </Button>
    </ButtonsContainer>
  </Container>
)

export default ProfileContractor
